module.exports = __webpack_public_path__ + "img/20200320105209QQ截图20190624162021.33d3a46e.png";